import { render, staticRenderFns } from "./RegistroHuella.vue?vue&type=template&id=92663bbe"
import script from "./RegistroHuella.vue?vue&type=script&lang=js"
export * from "./RegistroHuella.vue?vue&type=script&lang=js"
import style0 from "./RegistroHuella.vue?vue&type=style&index=0&id=92663bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports